<template>
  <section class="section">
    <Row>
      <Col span="24">
        <img class="logo" src="@/assets/logo.svg" alt="Logo" />
      </Col>
      <Col class="code mt-6" span="24">
        <span>404</span>
      </Col>

      <Col class="text mt-3" span="24">
        <span>{{ $l("route.notFound", "NOT FOUND") }}</span>
      </Col>
    </Row>
  </section>
</template>

<script>
import { Row, Col, Icon } from "iview";

export default {
  components: {
    Row,
    Col,
    Icon,
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: block;
  width: 30%;
  margin-left: auto;
  margin-right: auto;
}

.code,
.text {
  font-size: 40px;
  text-align: center;
}
</style>
